export default {
      id: "arrow-icon-light-usage",
      viewBox: "0 0 12 7",
      url: __webpack_public_path__ + "sprite.svg#arrow-icon-light",
      toString: function () {
        return this.url;
      }
    }